import { Pipe, PipeTransform } from '@angular/core';
import { HelperService } from '../../services/helper/helper.service';

@Pipe({
  name: 'studentName'
})
export class StudentNamePipe implements PipeTransform {

  transform(value: any): any {
    if (!value) {
      return value;
    }
    return HelperService.titleCase(value);
  }

}



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/shared/pipes/student-name.pipe.ts